export default __webpack_public_path__ + "static/media/pipelines-diffCommon.ae284712.svg";